export default "__VITE_ASSET__BD994MQx__"